import React, { useState } from 'react';
import { FaTerminal, FaStop } from 'react-icons/fa';
import { ExpandHeader, ToolCallWrapper } from '../shared/ToolCallComponents';
import { useAppStore } from '../../../../../../../GlobalStore/GlobalStore';

interface TerminalToolProps {
    item: any;
    isInProgress: boolean;
}

const sendStopTerminalCommand = (toolCallId: string, environment: string, vscode: any) => {
    const args = {
        functionName: "stopTerminalCommand",
        data: [{ toolCallId }]
    };

    if (environment.includes("jetbrains")) {
        window.jetbrainsPostMessage(JSON.stringify(args));
    } else if (environment === "vscode") {
        vscode.postMessage(args);
    }
};

const TerminalCommandContent: React.FC<{item: any}> = ({ item }) => {
    return (
        <div className={"ml-2"}>
            {item.args?.description && (
                <div className={"mb-2 text-neutral-500 dark:text-neutral-400"}>
                    {item.args.description}
                </div>
            )}
            {item.args?.command && (
                <div className="mb-2 bg-neutral-100 dark:bg-neutral-800 p-2 rounded-md">
                    <code className="text-sm text-neutral-700 dark:text-neutral-300">
                        {item.args.command}
                    </code>
                </div>
            )}
            {item.output && (
                <div className="pl-4 pr-2 py-2 mt-2 border border-neutral-200 dark:border-neutral-700 rounded-md bg-neutral-50 dark:bg-black overflow-x-auto">
                    <pre className="text-xs whitespace-pre-wrap text-neutral-700 dark:text-neutral-300">
                        {item.output}
                    </pre>
                </div>
            )}
        </div>
    );
};

const TerminalToolBase: React.FC<TerminalToolProps & {title: string}> = ({
    item,
    isInProgress,
    title
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;

    const handleStopClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        sendStopTerminalCommand(item.id, environment, vscode);
    };

    return (
        <ToolCallWrapper>
            <div className="flex items-center">
                <div className="flex-grow">
                    <ExpandHeader
                        icon={<FaTerminal className="mr-2 text-neutral-500 dark:text-neutral-400" size={14}/>}
                        title={title}
                        isExpanded={isExpanded}
                        isInProgress={isInProgress}
                        onClick={() => setIsExpanded(prev => !prev)}
                    />
                </div>
                {isInProgress && (
                    <button
                        onClick={handleStopClick}
                        className="ml-2 p-1.5 rounded-md hover:bg-neutral-200 dark:hover:bg-neutral-700 transition-colors"
                        title="Stop terminal command"
                    >
                        <FaStop className="text-red-500 dark:text-red-400" size={12} />
                    </button>
                )}
            </div>
            {isExpanded && <TerminalCommandContent item={item} />}
        </ToolCallWrapper>
    );
};

export const RunTerminalCommand: React.FC<TerminalToolProps> = (props) => (
    <TerminalToolBase
        {...props}
        title="Running Command"
    />
);
